module.exports = __webpack_public_path__ + "static/img/200053.83a28b83.png";